"use client";

import styled, { css, keyframes } from "styled-components";
import { space } from "styled-system";

import type { SvgProps } from "./types";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinStyle = css`
  animation: ${rotate} 2s linear infinite;
`;

const Svg = styled.svg<SvgProps>`
  flex-shrink: 0;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};

  ${({ spin }) => spin && spinStyle}
  ${space}
  
  path {
    fill: ${({ fill }) => fill};
    fill-opacity: ${({ opac }) => (opac ? 0.5 : 1)};
  }
`;

export default Svg;
